const locale = {
  id: 'PotentialClientConstant',
  code: 'CN',
  text: {
    "./images/potential-en.png": "./images/potential-cn.png",
    'Never Miss Any New Contact': '不再错过每一位联系人',
    'ClassTopBase can help you record every potential client, you can easily track them, no need to worry about missing anyone.': 'ClassTopBase 可以帮您记录每一位潜在用户，方便您对潜在用户进行追踪，不错过任何一位。',
  }
}

export const onBoardingContents = {
  title: __('Never Miss Any New Contact', locale),
  text: __('ClassTopBase can help you record every potential client, you can easily track them, no need to worry about missing anyone.', locale),
  image: require(__('./images/potential-en.png', locale)),
  showArrow: true,
}



// WEBPACK FOOTER //
// ./src/containers/pages/PotentialClient/constant.js